export const FooterReportsList = {
  title: 'Raporlar',
  items: [
    {
      text: 'Kullanım Özeti',
      link: '/ReportsPage',
    },
    {
      text: 'Ünvan Bilgileri',
      link: '/Title',
    },
  ],
};
export const FooterPackagesList = {
  title: 'Paketler',
  items: [
    {
      text: 'Kredi Satın Al',
      link: '/Packages',
    },
  ],
};
export const FooterMessagesList = {
  title: 'Mesajlar',
  items: [
    {
      text: 'Mesaj Gönder',
      link: '/Messages',
    },
    {
      text: 'Rehberim',
      link: '/Guide',
    },
    {
      text: 'Kara Liste',
      link: '/BlackList',
    },
  ],
};
export const FooterProfileList = {
  title: 'Profil',
  items: [
    {
      text: 'Profil Bilgileri',
      link: '/Profile',
    },
    {
      text: 'Ünvan İşlemleri',
      link: '/Title',
    },
  ],
};
export const FooterSupportList = {
  title: 'Yardım',
  items: [
    {
      text: 'Nasıl Satın Alabilirim',
      link: '/CreditPurchaseHelp',
    },
    {
      text: 'Mesaj Gönderimi',
      link: '/MessagesHelp',
    },
    {
      text: 'Raporlar',
      link: '/ReportsHelp',
    },
    {
      text: 'Şirket ve Hesaplar',
      link: '/AccountsHelp',
    },
  ],
};

export const FooterBlogList = {
  title: 'Blog',
  items: [
    {
      text: 'SMS Nedir',
      link: '/sms-nedir-sms-ve-toplu-sms-hakkinda-bilinmesi-gerekenler',
    },
    {
      text: "KOBİ'ler İçin Toplu SMS Hizmeti",
      link: '/kobiler-icin-toplu-sms',
    },
    {
      text: 'Bayram Mesajları',
      link: '/bayram-mesajlari',
    },
    { text: 'Yeni Yıl Mesajları', link: '/yeni-yil-mesajlari' },
    { text: 'Toplu SMS', link: '/toplu-sms' },
  ],
};
